import { GuidelineCategories } from 'consts/hiToolsConsts'
import AlignersTxTrackingCategory from './AlignersTxTrackingCategory'
import BracesTxTrackingCategory from './BracesTxTrackingCategory'
import ElasticsCategory from './ElasticsCategory'
import TxGoalsCategory from './TxGoalsCategory'
import IPRCategory from './IPRCategory'
import RPECategory from './RPECategory'
import RetentionTrackingCategory from './RetentionTrackingCategory'
import ObservationTrackingCategory from './ObservationTrackingCategory'

export default {
  [GuidelineCategories.AlignersTxTracking]: AlignersTxTrackingCategory,
  [GuidelineCategories.BracesTxTracking]: BracesTxTrackingCategory,
  [GuidelineCategories.Elastics]: ElasticsCategory,
  [GuidelineCategories.TxGoals]: TxGoalsCategory,
  [GuidelineCategories.RetentionTracking]: RetentionTrackingCategory,
  [GuidelineCategories.ObservationTracking]: ObservationTrackingCategory,
  [GuidelineCategories.IPR]: IPRCategory,
  [GuidelineCategories.RPE]: RPECategory
}
